// Common styles for the Billing Dashboard
const dashboardStyles = {
  // Card styles
  card: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    border: '1px solid #f0f0f0'
  },

  // Statistic card styles
  statisticCard: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    border: '1px solid #f0f0f0',
    height: '100%'
  },

  // Action card styles
  actionCard: {
    textAlign: 'center',
    borderRadius: '8px',
    transition: 'all 0.3s',
    height: '100%'
  },

  // Widget header styles
  widgetHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },

  // List styles
  listItem: {
    padding: '12px 0',
    borderBottom: '1px solid #f0f0f0'
  },

  // Button styles
  primaryButton: {
    borderRadius: '4px'
  },

  // Layout styles
  contentSection: {
    marginBottom: '24px'
  },

  // Chart styles
  chartContainer: {
    height: '300px',
    padding: '20px 0'
  }
}

export default dashboardStyles
